import { client } from "@/shared/api/pref-storage";
import { CategoryQuery } from "../../models/CategoryQuery";

const endpoints = {
  postQuery: "/headline-queries",
  getQueries: "/headline-queries",
};

export const postQuery = (query: CategoryQuery) => {
  return client.post(endpoints.postQuery, {
    name: query.queryName,
    tags: query.categories,
    search_keyword: query.searchKeyword,
    portfolio_ids: query.portfolioIds,
    tags_watchlist_ids: query.tagsWatchlistIds,
    keyword_op: query.keywordOp?.toUpperCase(),
    filter_op: query.filterMode?.toUpperCase(),
    keyword_watchlist_op: query.keywordWatchlistOp?.toUpperCase(),
    notifications: query.notifications,
  });
};

export const getQueries = (offset: number = 0, limit: number = 100) => {
  return client.get(endpoints.getQueries, {
    data: {
      offset,
      limit,
    },
  });
};

export const editQuery = (query: CategoryQuery) => {
  return client.patch(`${endpoints.getQueries}/${query.id}`, {
    name: query.queryName,
    tags: query.categories,
    search_keyword: query.searchKeyword,
    portfolio_ids: query.portfolioIds,
    tags_watchlist_ids: query.tagsWatchlistIds,
    keyword_op: query.keywordOp?.toUpperCase(),
    filter_op: query.filterMode?.toUpperCase(),
    keyword_watchlist_op: query.keywordWatchlistOp?.toUpperCase(),
    notifications: query.notifications,
  });
};

export const deleteQuery = (queryId: number) => {
  return client.delete(`${endpoints.getQueries}/${queryId}`);
};
